import React from 'react';
import numeral from 'numeral';

const NearbyLocationMapTooltip = ({ objectToDisplay, pointerX, pointerY }) => {
  return (
    <div style={{ position: 'absolute', zIndex: 3, pointerEvents: 'none', left: pointerX + 20, top: pointerY, ...styles.tooltipContainer }}>
      <span style={styles.title}>{objectToDisplay.name}</span><br />
      <span style={styles.brandName}>
        Dân số: <span style={styles.number}>{numeral(objectToDisplay.population).format('0,0')} người</span>
      </span><br />
      {objectToDisplay.area &&
        <span style={styles.brandName}>
          Diện tích: <span style={styles.number}>{objectToDisplay.area} km2</span>
        </span>
      }<br />
      {objectToDisplay.area &&
        <span style={styles.brandName}>
          Mật độ dân số: <span style={styles.number}>{numeral(objectToDisplay.population / objectToDisplay.area).format('0,0')} người / km2</span>
        </span>
      }
    </div>
  );
}

const styles = {
  tooltipContainer: {
    backgroundColor: 'var(--color-white)',
    padding: 12,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
    borderRadius: 4,
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
  },
  description: {
    fontSize: 14,
    whiteSpace: 'pre-line',
  },
  brandName: {
    fontSize: 12,
  },
  address: {
    marginTop: 6,
    fontSize: 12,
  },
  number: {
    fontWeight: 700,
  },
}

export default NearbyLocationMapTooltip;